import React from "react";

const ImportInstructions = () => {
    const importSteps = [
        {
            number: 1,
            title: "Nhập khách hàng",
            description: "Nhập thông tin khách hàng vào hệ thống.",
            fields: [
                "Tên khách hàng (bắt buộc)",
                "Mã khách hàng",
                "Số điện thoại",
                "Email",
                "Mã số thuế",
                "Cấp độ",
                "Danh mục",
                "Địa chỉ",
                "Số ngày nợ",
                "Hạn mức tín dụng",
                "Nội bộ",
                "Người liên hệ",
            ],
        },
        {
            number: 2,
            title: "Nhập nhà cung cấp",
            description: "Nhập thông tin nhà cung cấp vào hệ thống.",
            fields: [
                "Tên nhà cung cấp (bắt buộc)",
                "Mã nhà cung cấp",
                "Số điện thoại",
                "Email",
                "Mã số thuế",
                "Fax",
                "Địa chỉ",
                "Số ngày nợ",
                "Nội bộ",
                "Tên tài khoản ngân hàng",
                "Tên ngân hàng",
                "Số tài khoản",
                "Người liên hệ",
            ],
        },
        {
            number: 3,
            title: "Nhập quan hệ vật tư-nhà cung cấp",
            description: "Nhập quan hệ giữa vật tư và nhà cung cấp.",
            fields: [
                "Mã vật tư (bắt buộc)",
                "Tên vật tư (bắt buộc)",
                "Mã nhà cung cấp",
                "Giá nhập",
                "Kho số",
                "Hạng mục",
                "Đơn vị đo lường",
                "Mức cảnh báo tồn kho",
                "Ghi chú",
            ],
        },
        {
            number: 4,
            title: "Nhập định mức vật tư (BOM)",
            description: "Nhập định mức vật tư cho sản phẩm. Lưu ý: Vật tư phải được tạo trước khi nhập định mức vật tư.",
            fields: [
                "Mã sản phẩm",
                "Tên sản phẩm (bắt buộc)",
                "Danh mục sản phẩm",
                "Nhóm sản phẩm",
                "Kho số",
                "Mã vật tư (bắt buộc)",
                "Tên vật tư",
                "Hạng mục vật tư",
                "Ghi chú hạng mục",
                "Quy cách vật tư",
                "Số lượng",
                "Định lượng",
                "Tổng định lượng",
                "Ghi chú",
            ],
        },
        {
            number: 5,
            title: "Nhập quan hệ sản phẩm-khách hàng",
            description: "Nhập quan hệ giữa sản phẩm và khách hàng.",
            fields: [
                "Mã sản phẩm (bắt buộc)",
                "Tên sản phẩm (bắt buộc)",
                "Mã sản phẩm gốc (bắt buộc)",
                "Mã khách hàng (bắt buộc)",
                "Tên khách hàng",
                "Tên dịch vụ kèm theo",
                "Số lượng dịch vụ kèm theo",
                "Giá bán",
                "Số lượng",
                "Ghi chú",
            ],
        },
        {
            number: 6,
            title: "Nhập tồn kho vật tư",
            description: "Nhập số lượng tồn kho cho vật tư. Lưu ý: Vật tư phải được tạo trước khi nhập tồn kho.",
            fields: [
                "Mã vật tư (bắt buộc)",
                "Tên vật tư",
                "Kho số (bắt buộc, phải là 'Kho 1' hoặc 'Kho 2')",
                "Hạng mục",
                "Đơn vị đo lường",
                "Số lượng tồn kho (bắt buộc, >= 0)",
            ],
        },
    ];

    return (
        <div className="tw-p-6">
            <div className="tw-bg-yellow-50 tw-border tw-border-yellow-200 tw-rounded tw-p-3 tw-mb-4">
                <h3 className="tw-text-xs tw-font-semibold tw-text-yellow-800 tw-mb-2">
                    ⚠️ Lưu ý quan trọng về định dạng file Excel:
                </h3>
                <ul className="tw-text-xs tw-text-yellow-700 tw-space-y-1 tw-list-disc tw-list-inside">
                    <li>
                        Đảm bảo file Excel không có sheet ẩn, HOẶC sheet chính phải được đặt ở vị trí đầu tiên
                    </li>
                    <li>
                        Đảm bảo dòng 1 là hướng dẫn, có thể không có hướng dẫn nhưng phải có một số văn bản (parser sẽ bỏ qua nếu là dòng trống), dòng 2 là header tiếng Việt, dòng 3 là header tiếng Anh (quan trọng nhất).
                    </li>
                </ul>
            </div>
            <h2 className="tw-text-sm tw-font-medium tw-mb-3">
                Thứ tự nhập dữ liệu được khuyến nghị
            </h2>
            <div className="tw-space-y-3">
                {importSteps.map((step) => (
                    <div key={step.number}>
                        <h3 className="tw-text-xs tw-font-medium tw-text-gray-900 tw-mb-1">
                            {step.number}. {step.title}
                        </h3>
                        <p className="tw-text-xs tw-text-gray-700 tw-mb-1">
                            {step.description}
                        </p>
                        <p className="tw-text-xs tw-text-gray-600">
                            Các trường nhập: {step.fields.join(", ")}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImportInstructions;

